module.exports = __webpack_public_path__ + "img/the-netherlands-eye-and-ear-diseases-female.fd79537f.png";